import { render, staticRenderFns } from "./ScriveSignersTab.vue?vue&type=template&id=723df8f9&"
import script from "./ScriveSignersTab.vue?vue&type=script&lang=ts&"
export * from "./ScriveSignersTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports